"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRematchNotification = exports.rematchNotification = void 0;
function rematchNotification(playerId, rematchId) {
    return { playerId: playerId, rematchId: rematchId };
}
exports.rematchNotification = rematchNotification;
function isRematchNotification(notification) {
    return notification.rematchId != undefined;
}
exports.isRematchNotification = isRematchNotification;
//# sourceMappingURL=RematchNotification.js.map